import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, ViewController  } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { Globals } from '../../providers/globals';
import { BusinessInvoiceHandler } from '../../providers/business-invoice-handler';
import { BusinessProductPaymentManagerHandler } from '../../providers/business-product-payment-handler';

/**
 * Generated class for the BusinessProductPaymentVoidManagerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-business-product-payment-void-manager',
  templateUrl: 'business-product-payment-void-manager.html',
})
export class BusinessProductPaymentVoidManagerPage {
  private form : FormGroup;
  isLoading: boolean = false;
	isRedeeming: boolean = false;
	isRedeemed: boolean = false;
	invoice: any;
  filePath: any;

	constructor(
		public businessInvoiceHandler: BusinessInvoiceHandler, 
		public businessProductPaymentManagerHandler: BusinessProductPaymentManagerHandler,
		public alertCtrl: AlertController,
		public toastCtrl: ToastController,
		public navCtrl: NavController,
    public viewCtrl: ViewController,
    private formBuilder: FormBuilder,
		public globals: Globals, 
		public navParams: NavParams) {

		this.invoice = navParams.data["invoice"];
    this.filePath = this.globals.fileUrl;

    this.form = this.formBuilder.group({
	  	"ReversedReason":  ['', Validators.required]
   	});  
	}

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessProductPaymentVoidManagerPage');
  }

  confirmVoid(){
    let alert = this.alertCtrl.create({
      title: 'Void order?',
      message: 'Are you sure you want to void this order?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            
          }
        },
        {
          text: 'Confirm',
          handler: () => {  
            this.void();
          }
        }
      ]
    });

    alert.present();
  }    

  cancel(){

   		this.viewCtrl.dismiss(false);

	}

	void(){
    if(this.isRedeeming) return;

    this.isRedeeming = true;

    this.businessProductPaymentManagerHandler.void({
      Id: this.invoice.Id,
      ReversedReason: this.form.value.ReversedReason,
      cb:(result)=>{
        if(result.Success){

        	this.isRedeemed = true

          this.isRedeeming = false;

          this.viewCtrl.dismiss(true);

          
        } else { 
          
          let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: result.Message,
              buttons: ['Ok']
            });
            
            alert.present();

            this.isRedeeming = false; 
        }
      }
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/business-product-payment-void-manager/business-product-payment-void-manager.ts